import React, {Component} from 'react';
import {actions, Control, Errors, Form} from 'react-redux-form';
import {connect} from 'react-redux';
import {Link, Redirect} from 'react-router-dom';
import {Button, Checkbox, Col, ControlLabel, FormControl, FormGroup, Grid, Radio, Row} from 'react-bootstrap';
import InlineCKEditor from '../common/editor/inline-editor';
import PageTitle from '../common/page-title/index';
import RequiredInput from '../common/form/elements/required-input';
import TextViewer from '../common/editor/text-viewer';
import {isLoggedIn} from '../../utils/tokenUtils';
import {loadPageContent} from '../../actions/content';
import {updateOutlet} from '../../actions/outlet';
import t from '../../data/translations';
import { tradeSiteEnabled, tradeSiteDisabled } from '../../utils/toggles';
import IgniteUkLogo from '../../assets/img/ignite_logo_black.png';

import './style.css';

class YourStoreForm extends Component {
  handleSubmit = (payLoad) => {
    const { dispatch, location: { pathname }} = this.props;

    dispatch(actions.submitFields(
      'deep.yourStore',
      updateOutlet(payLoad, this.state.addMore, {
        ...this.props.registration,
        fromRegistrationPage: pathname.startsWith('/registration/')
      })
    ));
  };
  handleAddMore = (event) => {
    this.setState({
      addMore: event.target.value === 'true'
    });
  };
  handleContentSaved = () => {
    this.props.dispatch(loadPageContent(`api/pages/${this.pageSlug}`));
  };

  constructor(props) {
    super(props);

    this.pageSlug = 'your-store';
    this.state = {
      addMore: ''
    };
  }

  componentWillMount() {
    if (this.props.registration.pending && this.props.registration.internal) {
      this.props.dispatch(loadPageContent(`api/pages/${this.pageSlug}`));
    }
  }

  componentWillUnmount() {
    this.props.dispatch(actions.reset('deep.yourStore'));
  }

  render() {
    if (!(this.props.eircode || this.props.passcode || tradeSiteEnabled())) {
      if (isLoggedIn()) {
        return (<Redirect to="/outlet"/>);
      }
      return (<Redirect to="/registration/outlet"/>);
    }
    const formFields = (
      <div>
        {this.props.customer_number && (
        <FormGroup controlId="customer_number">
          <ControlLabel>
                Customer Number
          </ControlLabel>
          <Control.text readOnly model=".customer_number" value={this.props.customer_number} component={FormControl}/>
        </FormGroup>
          )}

        <Errors
          className="errors"
          messages={{
              customer_number: 'This field is required'
            }}
          model=".customer_number"
          show={{focus: false}}
        />

        <RequiredInput
          controlId="name"
          inputType="text"
          label="Store Name"
          model=".updated_name"
        />

        <RequiredInput
          controlId="address_1"
          inputType="text"
          label="Address Line 1"
          model=".updated_address_1"
        />

        <FormGroup controlId="address_2">
          <ControlLabel>
              Address Line 2
          </ControlLabel>
          <Control.text component={FormControl} model=".updated_address_2"/>
        </FormGroup>
        <Errors
          className="errors"
          messages={{
              updated_address_2: 'This field is required'
            }}
          model=".updated_address_2"
          show={{focus: false}}
        />

        <FormGroup controlId="address_3">
          <ControlLabel>
              Address Line 3
          </ControlLabel>
          <Control.text component={FormControl} model=".updated_address_3"/>
        </FormGroup>
        <Errors
          className="errors"
          messages={{
              updated_address_3: 'This field is required'
            }}
          model=".updated_address_3"
          show={{focus: false}}
        />

        <RequiredInput
          controlId="town"
          inputType="text"
          label="Town/City"
          model=".updated_town"
        />

        <RequiredInput
          controlId="county"
          inputType="text"
          label="County"
          model=".updated_county"
        />

        <FormGroup controlId="updated_eircode" validationState={this.props.eircodeValid ? null : 'error'}>
          <ControlLabel>{t('eircode')}*</ControlLabel>
          <Control.text
            component={FormControl}
            disabled={this.props.dont_know_eircode}
            model=".updated_eircode"
          />

          <Errors
            className="errors"
            messages={{ required: 'This field is required' }}
            model=".updated_eircode"
            show={{ touched: true, focus: false }}
          />
        </FormGroup>

        <FormGroup controlId="dont_know_eircode">
          <Control.checkbox component={Checkbox} model=".dont_know_eircode">
            {t('yourStore.iDontKnowEircode')}
          </Control.checkbox>
        </FormGroup>

        {tradeSiteDisabled() && this.props.pfp && (
        <Control.checkbox component={Checkbox} model=".pfp">
              This store is eligible to earn rewards. Please read and accept the reward
          {' '}
          <Link to="/content-pages/rewards-terms-conditions">
                terms & conditions
          </Link>
              .
        </Control.checkbox>
          )}

        <FormGroup controlId="addMore">
          <ControlLabel>
              Do you have any more stores to add to your account?
          </ControlLabel>
          <div>
            <Radio
              checked={this.state.addMore === true}
              className="pull-left"
              inline
              name="addMore"
              onChange={this.handleAddMore}
              value="true"
            >
                Yes
            </Radio>
            <Radio
              checked={this.state.addMore === false}
              className="pull-left"
              inline
              name="addMore"
              onChange={this.handleAddMore}
              value="false"
            >
                No
            </Radio>
          </div>
        </FormGroup>

        <Control model=".eircode" type="hidden"/>
        <Control model=".customer_number" type="hidden" value={this.props.customer_number}/>

        <Button
          className="btn red-ghost-btn pull-right"
          disabled={!(this.props.formValid && !(this.state.addMore === ''))}
          type="submit"
        >
            Next
        </Button>
      </div>
    );

    return (
      <Grid className="your-store user-inner-container" fluid={this.props.registration.internal}>
        <Row>
          <Col md={12}>
            {this.props.area !== 'retailer' && (
              <img src={IgniteUkLogo} alt="Ignite UK" />
            )}
            <div className={this.props.area === 'retailer' ? 'your-store-title' : '' }>
              <PageTitle>
                Your store
              </PageTitle>
            </div>
          </Col>
        </Row>
        {
          this.props.registration.pending && this.props.registration.internal && (
            <Row>
              <Col lg={12}>
                <InlineCKEditor
                  contents={this.props.contents[`${this.pageSlug}_content_text`]}
                  identifier={`${this.pageSlug}_content_text`}
                  onContentSaved={this.handleContentSaved}
                />
              </Col>
            </Row>
          )}
        {
          !(this.props.registration.pending && this.props.registration.internal) &&
          <TextViewer pageSlug='your-store'></TextViewer>
        }
        <Row>
          <Col md={12}>
            <Errors className="errors" model="deep.yourStore"/>
          </Col>
        </Row>
        <Row className="show-grid">
          <Col lg={12}>
            <Form
              className="your-store-form"
              model='deep.yourStore'
              onSubmit={this.handleSubmit}
              validators={{
              updated_eircode: {
                required: value => this.props.dont_know_eircode || value.trim().length > 0
              }
            }}
            >
              {formFields}
            </Form>
          </Col>
        </Row>
      </Grid>
    );
  }
}

const mapStateToProps = state => ({
  eircode: state.aboutYou.outlet.eircode,
  passcode: state.aboutYou.outlet.passcode,
  customer_number: state.aboutYou.outlet.customer_number || '',
  pfp: state.aboutYou.outlet.pfp,
  registration: state.registration,
  dont_know_eircode: state.deep.yourStore.dont_know_eircode,
  formValid: state.deep.forms.yourStore.$form.valid,
  contents: state.content.list,
  eircodeValid: state.deep.forms.yourStore.updated_eircode.valid
});

export default connect(mapStateToProps)(YourStoreForm);



// WEBPACK FOOTER //
// ./src/components/your-store/index.jsx